import {gsap} from "gsap/gsap-core";
import {Random} from "@dp-instant/utils";
import {Action, lazyGet} from "@dp-instant/core";
import {inject, injectable} from "inversify";
import {Point, Sprite} from "pixi.js-legacy";
import {Fighter} from "@game/coregame/ecs/entities/Fighter";
import {FighterView} from "@game/coregame/view/FighterView";
import {TypesGame} from "@game/TypesGame";
import {Container} from "pixi.js-legacy";

@injectable()
export class FighterDeathEffectAction extends Action<Fighter[]> {
    @inject("skull.svg")
    private skull: Sprite;

    async execute(data: Fighter[]) {
        for (let i = 0; i < data.length; i += 2) {
            const fighter1 = data[i];
            const fighter2 = data[i + 1];

            const view1 = fighter1.get(FighterView)!,
                view2 = fighter2.get(FighterView)!;

            const pos1 = view1.position,
                pos2 = view2.position;

            const skull = this.skull;
            skull.tint = Random.from(fighter1.color, fighter2.color);
            skull.width = view1.width;
            skull.pivot.set(0.5);
            skull.scale.set(0.15);
            skull.position.set((pos1.x + pos2.x) / 2, (pos1.y + pos2.y) / 2);
            const fromPosition = new Point((pos1.x + pos2.x) / 2, (pos1.y + pos2.y) / 2);
            const toPosition = fromPosition.clone();
            const toScale = skull.scale.clone();
            toScale.x *= 2;
            toScale.y *= 2;
            toPosition.y -= skull.height * 5;
            gsap.timeline()
                .fromTo(
                    skull,
                    {x: fromPosition.x, y: fromPosition.y, alpha: 0},
                    {x: toPosition.x, y: toPosition.y, alpha: 0.5}
                )
                .add(
                    gsap.to(skull.scale, {
                        x: toScale.x,
                        y: toScale.y,
                        onComplete: () => {
                            skull.parent?.removeChild(skull);
                        }
                    }),
                    0
                )
                .add(gsap.to(skull, {alpha: 0}), 0.3);
            lazyGet<Container>(TypesGame.views.fieldInstance)?.addChild(skull);
        }
    }
}
